import { selectLowRateMortgage } from './selectLowRateMortgage';
import { IApplicationState } from '../../types/redux';

export const selectLowRateMortgageTitle = (state: IApplicationState): string => {
  const lowRateMortgage = selectLowRateMortgage(state);

  return lowRateMortgage.title;
};
